import { render, staticRenderFns } from "./StepFilterConfigV2.vue?vue&type=template&id=4bde572a&scoped=true"
import script from "./StepFilterConfigV2.vue?vue&type=script&lang=js"
export * from "./StepFilterConfigV2.vue?vue&type=script&lang=js"
import style0 from "./StepFilterConfigV2.vue?vue&type=style&index=0&id=4bde572a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde572a",
  null
  
)

export default component.exports